import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PageTransition from '../components/PageTransition'; // Assuming you still want your page transitions

export default function Login() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // This remembers where you were trying to go (e.g., /invoice)
  const from = location.state?.from?.pathname || "/invoice";

  const handleLogin = (e) => {
    e.preventDefault();
    
    if (password === 'aezakmi') {
      localStorage.setItem('invoiceAuth', 'true');
      setError(false);
      navigate(from, { replace: true }); 
    } else {
      setError(true);
      setPassword('');
    }
  };

  return (
<PageTransition title="Login">
      <div className="min-h-screen bg-zinc-900 flex items-center justify-center px-4 md:px-8 font-['Montserrat',sans-serif] text-white">
        <div className="max-w-md w-full grid gap-12">
          
          {/* Header */}
          <div>
            <h2 className="text-4xl md:text-5xl font-medium mb-3">Admin Access</h2>
            <p className="text-zinc-500 text-sm uppercase tracking-wider font-medium">
              SECURED AREA
            </p>
          </div>
          
          {/* Form */}
          <form onSubmit={handleLogin} className="grid gap-12">
            <div>
              <input
                type="password"
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={`bg-transparent border-b pb-3 outline-none text-xl md:text-2xl text-white placeholder-zinc-700 transition-colors w-full ${
                  error ? 'border-red-500 focus:border-red-400' : 'border-zinc-800 focus:border-zinc-400'
                }`}
              />
              {error && (
                <p className="text-red-500 text-sm mt-3">
                  Incorrect password. Try again.
                </p>
              )}
            </div>
            
            <button
              type="submit"
              className="w-full bg-white text-black py-4 md:py-5 rounded-full text-lg md:text-xl font-medium hover:bg-zinc-200 transition-all"
            >
              Access Generator
            </button>
          </form>

        </div>
      </div>
    </PageTransition>
  );
}